import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: '',
  async getComponent (nextState) {
    const {
      default: PricingContainer
    } = await import('../pricing/components/PricingContainer')
      .catch(handleChunkLoadError);
    return PricingContainer;
  },
  children: [
    {
      path: '/p/wf-pricing',
      async getComponent (nextState) {
        const {
          default: PricingContainer
        } = await import('../pricing/components/PricingPage')
          .catch(handleChunkLoadError);
        return PricingContainer;
      },
      getData: ({ context: { props } }) => (props)
    }
  ]
});
